
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandSection from './components/BrandSection';
import AuthoritySection from './components/AuthoritySection';
import StrengthSection from './components/StrengthSection';
import AnchorSection from './components/AnchorSection';
import FactorySection from './components/FactorySection';
import { updateSEO, addJSONLD } from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    // Update SEO
    updateSEO({
      title: '南滇古茶 - 专业普洱茶供应链平台',
      description: '南滇古茶是专业的普洱茶供应链平台，提供品牌孵化、主播合作、工厂直供等一站式服务。精选云南优质茶叶，传承古法工艺，打造高品质茶品。',
      keywords: '南滇古茶,普洱茶,茶叶批发,品牌孵化,主播合作,工厂直供,云南茶叶,古法工艺',
      type: 'website',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
    });

    // Add JSON-LD structured data
    addJSONLD({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "南滇古茶",
      "description": "专业普洱茶供应链平台，提供品牌孵化、主播合作、工厂直供等一站式服务",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "logo": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/favicon.ico`,
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "business"
      },
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "CN",
        "addressRegion": "云南省"
      },
      "founder": {
        "@type": "Person",
        "name": "南滇古茶创始人"
      },
      "foundingDate": "2020",
      "industry": "Tea Manufacturing and Distribution",
      "numberOfEmployees": "50-100"
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <BrandSection />
        <AuthoritySection />
        <StrengthSection />
        <AnchorSection />
        <FactorySection />
      </main>
      <Footer />
    </div>
  );
}
